import Vue from "vue";
import Vuex from "vuex";
import i18n from "@/lang/i18n";
import * as at from "@/store/action-types";
import axiosInstance from "@/services/http/axios-instance";
import { UserApi } from "@/office/user/user-api";

Vue.use(Vuex);

const selectedLocale = localStorage.getItem("selectedLocale") || "uk";

export default new Vuex.Store({
  state: {
    app: {
      currentLocale: selectedLocale,
    },
    user: {
      phone: null,
      accessToken: null,
      refreshToken: null,
      isLoggedIn: false,
      otpOperationId: null,
      transactionId: null,
      loginTransactionId: null,
      data: {},
    },
    cart: {
      itemsCount: 0,
    },
    wss: null,
  },
  getters: {
    userLoggedIn: (state) => state.user.isLoggedIn,
    userData: (state) => state.user.data,
    cartItemsCount: (state) => state.cart.itemsCount,
    loginTransactionId: (state) => state.user.loginTransactionId,
    currentLanguage: (state) => state.app.currentLocale,
  },
  mutations: {
    [at.LOGIN_USER](state, payload) {
      state.user.accessToken = payload.accessToken;
      state.user.phone = payload.phone;
      state.user.isLoggedIn = true;
    },
    [at.UPDATE_TOKENS](state, tokens) {
      state.user.accessToken = tokens.accessToken;
    },
    [at.LOGOUT_USER](state) {
      state.user.accessToken = null;
      state.user.refreshToken = null;
      state.user.phone = null;
      state.user.isLoggedIn = false;
    },
    [at.SET_USER_DATA](state, userData) {
      state.user.data = userData;
    },
    [at.SET_LOCALE](state, locale) {
      i18n.locale = locale;
      state.app.currentLocale = locale;
    },
    [at.SET_USER_PHONE](state, phone) {
      state.user.phone = phone;
    },
    [at.SET_OTP_OPERATION_ID](state, operationId) {
      state.user.otpOperationId = operationId;
    },
    [at.SET_LOGIN_TRANSACTION_ID](state, transactionId) {
      state.user.loginTransactionId = transactionId;
    },
    [at.UPDATE_CART_ITEMS_COUNT](state, itemsCount) {
      state.cart.itemsCount = itemsCount;
    },
    [at.SET_WSS_CONNECTION](state, wss) {
      state.wss = wss;
    },
  },
  actions: {
    async [at.LOGIN_USER]({ commit, dispatch }, payload) {
      localStorage.setItem("accessToken", payload.accessToken);
      localStorage.setItem("phone", payload.phone);

      axiosInstance.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${payload.accessToken}`;

      commit(at.LOGIN_USER, payload);
      await dispatch(at.LOAD_USER_DATA);
    },
    [at.UPDATE_TOKENS]({ commit }, tokens) {
      localStorage.setItem("accessToken", tokens.accessToken);
      localStorage.setItem("refreshToken", tokens.refreshToken);
      axiosInstance.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${tokens.accessToken}`;

      commit(at.UPDATE_TOKENS, tokens);
    },
    async [at.LOAD_USER_DATA]({ commit }) {
      await new UserApi()
        .loadUserData()
        .then((r) => {
          commit(at.SET_USER_DATA, r.data);
        })
        .catch(() => {});
    },
    [at.LOGOUT_USER]({ commit }) {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("phone");
      localStorage.removeItem("otpOperationId");
      commit(at.LOGOUT_USER);
    },
    [at.SET_LOCALE]({ commit }, locale) {
      localStorage.setItem("selectedLocale", locale);
      commit(at.SET_LOCALE, locale);
    },
    [at.SET_USER_PHONE]({ commit }, phone) {
      localStorage.setItem("phone", phone);
      commit(at.SET_USER_PHONE, phone);
    },
    [at.SET_OTP_OPERATION_ID]({ commit }, operationId) {
      localStorage.setItem("otpOperationId", operationId);
      commit(at.SET_OTP_OPERATION_ID, operationId);
    },
    [at.SET_LOGIN_TRANSACTION_ID]({ commit }, transactionId) {
      localStorage.setItem("loginTransactionId", transactionId);
      commit(at.SET_LOGIN_TRANSACTION_ID, transactionId);
    },
    [at.UPDATE_CART_ITEMS_COUNT]({ commit }, itemsCount) {
      commit(at.UPDATE_CART_ITEMS_COUNT, itemsCount);
    },
    [at.SET_WSS_CONNECTION]({ commit }, wss) {
      commit(at.SET_WSS_CONNECTION, wss);
    },
  },
  modules: {},
});
